import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../admin/contexts/AuthContext';
import { AdminLayout } from './components/AdminLayout/AdminLayout';
import { Login } from './pages/Login/Login';
import { AdminProjects } from './pages/Projects/Projects';
import { ProjectEdit } from './pages/ProjectEdit/ProjectEdit';
import { AdminNews } from './pages/News/News';
import { NewsEdit } from './pages/NewsEdit/NewsEdit';
import { AdminLogging } from './pages/Logging/Logging';
import { Settings } from './pages/Settings/Settings';
import { AdminUsers } from './pages/AdminUsers/AdminUsers';

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();

    if (loading) {
        return <div>Загрузка...</div>;
    }

    if (!isAuthenticated) {
        return <Navigate to="/admin/login" replace />;
    }

    return <>{children}</>;
};

export const AdminApp: React.FC = () => {
    return (
        <Routes>
            <Route path="login" element={<Login />} />
            <Route
                path="/*"
                element={
                    <ProtectedRoute>
                        <AdminLayout />
                    </ProtectedRoute>
                }
            >
                <Route index element={<Navigate to="/admin/news" replace />} />
                <Route path="projects" element={<AdminProjects />} />
                <Route path="projects/new" element={<ProjectEdit />} />
                <Route path="projects/:id" element={<ProjectEdit />} />
                <Route path="news" element={<AdminNews />} />
                <Route path="news/new" element={<NewsEdit />} />
                <Route path="news/:id" element={<NewsEdit />} />
                <Route path="logging" element={<AdminLogging />} />
                <Route path="settings" element={<Settings />} />
                <Route path="users" element={<AdminUsers />} />

            </Route>
        </Routes>
    );
};